import { createSelector } from 'reselect';

const selectCaseState = (state) => state.case;

export const selectUpdateReferencesPending = createSelector(
  selectCaseState,
  (caseState) => caseState.updateReferencesPending,
);

export const selectUpdateReferencesResult = createSelector(
  selectCaseState,
  (caseState) => caseState.updateReferencesResult,
);

export const selectGenerateReferenceCandidatesPending = createSelector(
  selectCaseState,
  (caseState) => caseState.generateReferenceCandidatesPending,
);

export const selectGenerateReferenceCandidatesResult = createSelector(
  selectCaseState,
  (caseState) => caseState.generateReferenceCandidatesResult,
);

export const selectGenerateReferenceSequencePending = createSelector(
  selectCaseState,
  (caseState) => caseState.generateReferenceSequencePending,
);

export const selectGenerateReferenceSequenceResult = createSelector(
  selectCaseState,
  (caseState) => caseState.generateReferenceSequenceResult,
);

export const selectTakeReferencePending = createSelector(
  selectCaseState,
  (caseState) => caseState.takeReferencePending,
);

export const selectTakeReferenceResult = createSelector(
  selectCaseState,
  (caseState) => caseState.takeReferenceResult,
);

export const selectTakeReferenceWithNamesPending = createSelector(
  selectCaseState,
  (caseState) => caseState.takeReferenceWithNamesPending,
);

export const selectTakeReferenceWithNamesResult = createSelector(
  selectCaseState,
  (caseState) => caseState.takeReferenceWithNamesResult,
);
